<template>
  <BaseTooltip interactive :position="tooltipPosition">
    <template #trigger>
      <slot name="icon" />
      <img
        v-if="!iconSlotExists"
        :src="helpIcon"
        alt="help"
        :class="['trigger-icon', `trigger-icon--size-${iconSize}`]"
      />
    </template>
    <template #content>
      <div class="content">
        <div class="content__title">
          <slot name="title" />
        </div>
        <div class="content__text">
          <slot name="description" />
        </div>
      </div>
    </template>
  </BaseTooltip>
</template>

<script>
import { helpIcon } from '@/assets/img/'
import BaseTooltip from '@/components/generics/base/BaseTooltip.vue'

export default {
  components: {
    BaseTooltip,
  },
  props: {
    tooltipPosition: {
      type: String,
      required: false,
      default: 'bottom',
    },
    iconFileName: {
      type: String,
      required: false,
      default: 'help.svg',
    },
    iconSize: {
      type: String,
      required: false,
      default: 'small',
    },
  },
  data() {
    return { helpIcon }
  },
  computed: {
    iconSlotExists() {
      return !!this.$slots.icon
    },
  },
}
</script>

<style lang="scss" scoped>
.trigger-icon {
  object-fit: contain;

  &--size-small {
    width: $spacing-2xs;
    height: $spacing-2xs;
  }

  &--size-medium {
    width: $spacing-s;
    height: $spacing-s;
  }

  &--size-large {
    width: $spacing-m;
    height: $spacing-m;
  }
}
.content {
  padding: $spacing-4xs;

  &__title {
    @include micro-header;
    margin-bottom: $spacing-5xs;
    color: $color-text-light;
  }

  &__text {
    font-weight: 400;
    color: $color-text;
    white-space: pre-wrap;
  }
}
</style>
